import React from 'react';
import { Badge } from 'flowbite-react';
import { Button } from 'modules/v2/common/AtomicDesign/atoms';

const TemplateCard = ({ template, onCustomize, onPreview }) => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow overflow-hidden max-w-[290px]">
    <div className="group hover:brightness-[90%] transition duration-300 ease-in-out aspect-[3/4] bg-gray-100 overflow-hidden relative max-h-[384px]">
      {template.thumbnail_url || template.smartThumbnailUrl ? (
        <img
          src={template?.smartThumbnailUrl || template.thumbnail_url}
          alt={template.template_title || 'Template'}
          className="h-full w-full object-contain group-hover:scale-110 transition duration-300 ease-in-out"
          style={{ imageRendering: 'crisp-edges' }}
          onError={(e) => {
            const target = e.target;
            target.style.display = 'none';
            const nextElement = target.nextElementSibling;
            if (nextElement) {
              nextElement.style.display = 'flex';
            }
          }}
        />
      ) : (
        <div className="absolute inset-0 bg-gray-200 flex items-center justify-center text-gray-400">
          <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
      )}
      {/* <div className="absolute top-[5%] right-[5%]">
        <Badge className="text-orange-600 bg-orange-50 group-hover:bg-orange-50 text-sm leading-5 font-semibold">{template?.primary_template_category_item?.item_name}</Badge>
      </div> */}
      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
        <div className="flex flex-col w-[90%] gap-2">
          <Button
            className="min-w-[100%]"
            onClick={() => onCustomize(template)}
          >
            <span className="invisible group-hover:visible ">Customize</span>
          </Button>
          <Button
            className="min-w-[100%]"
            onClick={() => onPreview(template)}
            type="outlined"
          >
            <span className="flex gap-1 invisible group-hover:visible">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>

              Preview
            </span>
          </Button>
        </div>
      </div>
    </div>

    <div className="bg-white border-t border-gray-200 text-sm leading-5 font-semibold p-4 pt-2">
      {template?.template_title}
    </div>
  </div>
);

export default TemplateCard;